import { jsx as _jsx } from "react/jsx-runtime";
import styles from './PageContainer.module.scss';
const PageContainer = ({ children }) => {
    return (_jsx("div", { className: styles.root, children: children }));
};
export default PageContainer;
